// ** React Imports
import { SyntheticEvent, useState, useContext } from 'react'

// ** MUI Imports
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import Grid from '@mui/material/Grid'
import Pagination from '@mui/material/Pagination'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Theme } from '@mui/material/styles'

// ** Axios

// ** Hook Imports
import useFetch from 'src/hooks/useFetch'
import useSWR from 'swr'
import { AuthContext } from 'src/context/AuthContext'

// ** Configs
import endPoint from 'src/configs/endpoints/rekrutmenEndPoints'

// ** Custom Components Imports
import CustomYellowCard from 'src/components/rekrutmen/CustomYellowCard'
import CustomAlertNotFound from 'src/components/rekrutmen/CustomAlertNotFound'
import CustomSearchBox from './CustomSearchBox'
import SpinnerSmall from 'src/components/SpinnerSmall'

import { RekrutmenList } from 'src/types/rekrutmen-list'

interface Klasifikasi {
  id: string
  rekrutmen_klasifikasi: string
  created_at: string
  updated_at: string
}

interface responseKlasifikasi {
  success: string
  message: string
  data: Klasifikasi[]
}

interface rekrutmenResponse {
  success: boolean
  message: string
  data: RekrutmenList[]
}

const TabsFullWidth = () => {
  const auth = useContext(AuthContext)

  const { FetchWithPayload } = useFetch()
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  const [searchValue, setSearchValue] = useState('')

  const payloadKlasifikasi = {
    url: `${endPoint.rekrutmenKlasifikasiEndpoint}`,
    method: 'GET'
  }

  const { data: dataKlasifikasi, isLoading: isLoadingKlasifikasi } = useSWR<responseKlasifikasi>(
    [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payloadKlasifikasi],
    FetchWithPayload
  )

  const visibleDataKlasifikasi = dataKlasifikasi && dataKlasifikasi.data && dataKlasifikasi?.data.filter(ele => (auth.user ? true : ele.id != '5'))

  const payload = {
    url: `${endPoint.rekrutmenListPublicEndpoint}`,
    method: 'GET'
  }

  const { data, isLoading } = useSWR<rekrutmenResponse>(
    [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payload],
    FetchWithPayload
  )

  const visibleData = data && data.data && data?.data.filter(ele => (auth.user ? true : ele.rekrutmen_klasifikasi_id != '5'))

  // ** State
  const [value, setValue] = useState<string>('0')
  const [page, setPage] = useState(1)
  const pageSize = 6

  const handleChange = (_event: SyntheticEvent, newValue: string) => {
    setValue(newValue)
    setPage(1)
  }

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value)
  }

  return (
    <Box>
      <Box sx={{ mb: 16 }}>
        <CustomSearchBox setSearchValue={setSearchValue} mobile={mobile} />
      </Box>
      <TabContext value={value}>
        <TabList
          variant={mobile ? 'scrollable' : 'fullWidth'}
          onChange={handleChange}
          aria-label='rekrutmen'
          sx={{
            '& .MuiTab-root': {
              borderBottom: theme => `4px solid ${theme.palette.divider}`,
              fontWeight: 500,
              textTransform: 'none'
            },
            '& .Mui-selected': {
              fontWeight: 600
            },
            '& .MuiTabs-indicator': {
              height: 4
            }
          }}
        >
          <Tab value='0' label='Semua Rekrutmen' />
          {!isLoadingKlasifikasi &&
            visibleDataKlasifikasi &&
            visibleDataKlasifikasi
              .filter(ele => (auth.user ? true : ele.id != '5'))
              .map(ele => <Tab key={ele.id} value={ele.id} label={ele.rekrutmen_klasifikasi} />)}
        </TabList>

        <TabPanel value='0' sx={{ p: 0 }}>
          <Grid container sx={{ py: 10 }}>
            {!isLoading && visibleData ? (
              visibleData.filter(ele => {
                if (searchValue == '') return true
                else return ele.judul.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
              }).length > 0 ? (
                visibleData
                  .filter(ele => {
                    if (searchValue == '') return true
                    else return ele.judul.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
                  })
                  .map((ele, index) => {
                    if (index >= pageSize * page - pageSize && index < pageSize * page) {
                      return (
                        <Grid key={ele.id} item xs={12} sm={6} md={6} lg={4}>
                          <CustomYellowCard data={ele} />
                        </Grid>
                      )
                    }
                  })
              ) : (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CustomAlertNotFound />
                </Grid>
              )
            ) : (
              <Grid item xs={12} sx={{ position: 'relative', height: 300, borderRadius: 1, overflow: 'hidden' }}>
                <SpinnerSmall />
              </Grid>
            )}
          </Grid>
        </TabPanel>

        {!isLoadingKlasifikasi &&
          visibleDataKlasifikasi &&
          visibleDataKlasifikasi.map(klasifikasi => (
            <TabPanel key={klasifikasi.id} value={klasifikasi.id} sx={{ p: 0 }}>
              <Grid container sx={{ py: 10 }}>
                {!isLoading && visibleData ? (
                  visibleData.filter(ele => {
                    if (searchValue == '') return ele.rekrutmenklasifikasi.id == klasifikasi.id
                    else
                      return (
                        ele.rekrutmenklasifikasi.id == klasifikasi.id &&
                        ele.judul.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
                      )
                  }).length > 0 ? (
                    visibleData
                      .filter(ele => {
                        if (searchValue == '') return ele.rekrutmenklasifikasi.id == klasifikasi.id
                        else
                          return (
                            ele.rekrutmenklasifikasi.id == klasifikasi.id &&
                            ele.judul.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
                          )
                      })
                      .map((ele, index) => {
                        if (index >= pageSize * page - pageSize && index < pageSize * page) {
                          return (
                            <Grid key={ele.id} item xs={12} sm={6} md={6} lg={4}>
                              <CustomYellowCard data={ele} />
                            </Grid>
                          )
                        }
                      })
                  ) : (
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                      <CustomAlertNotFound />
                    </Grid>
                  )
                ) : (
                  <Grid item xs={12} sx={{ position: 'relative', height: 300, borderRadius: 1, overflow: 'hidden' }}>
                    <SpinnerSmall />
                  </Grid>
                )}
              </Grid>
            </TabPanel>
          ))}

        {!isLoading &&
          visibleData &&
          visibleData.filter(ele => ele.rekrutmenklasifikasi.id == value || value == '0').length > 0 && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Pagination
                color='primary'
                count={Math.ceil(
                  visibleData.filter(ele => ele.rekrutmenklasifikasi.id == value || value == '0').length / 6
                )}
                page={page}
                onChange={handleChangePage}
              />
            </Box>
          )}
      </TabContext>
    </Box>
  )
}

export default TabsFullWidth
